import { useRef, useState, useEffect, useCallback, useLayoutEffect } from "react";
import { getAddressInfo } from "../../getAddressInfo.js";
import { useGoogleLoader } from "../GoogleLoaderProvider.js";
import "react/jsx-runtime";
import "../../../components/Button/Button.js";
import "../../../components/InputControl/InputControl.js";
import "../../../components/InputControl/Input/InputBase.js";
import "../../../components/PhoneInputControl/PhoneInputControl.js";
import "../../../components/PhoneInputControl/PhoneInput/PhoneInput.js";
import "../../../components/IconButton/IconButton.js";
import "../../../components/common/ControlBody.js";
import "@mui/material";
import "../../../components/IconButtonNew/IconButton.js";
import "../../../icons/24/Action/Close.js";
import "../../../icons/24/Arrow/ChevronLeft.js";
import "../../../components/Dropdown/context/DropdownContext.js";
import "../../../components/Dropdown/DropdownWindow.js";
import "../../../icons/24/System/Check.js";
import "../../../icons/24/Arrow/ChevronDown.js";
import "../../../components/SelectControl/SelectInput/SelectInput.js";
import "../../../components/TextareaControl/TextareaControl.js";
import "../../../components/SearchControl/SearchControl.js";
import "../../../icons/24/System/Search.js";
import "../../../components/FormattedPhone/FormattedPhoneNumber.js";
import "../../../icons/24/Action/Attach.js";
import "../../../icons/24/Action/Camera.js";
import "../../../icons/24/Action/CameraPlus.js";
import "../../../icons/24/Action/Cart.js";
import "../../../icons/24/Action/ChatText.js";
import "../../../icons/24/Action/ClockClockwise.js";
import "../../../icons/24/Action/ClockCounterClockwise.js";
import "../../../icons/24/Action/Comment.js";
import "../../../icons/24/Action/Copy.js";
import "../../../icons/24/Action/DelayedResult.js";
import "../../../icons/24/Action/Delete.js";
import "../../../icons/24/Action/DeliveredResult.js";
import "../../../icons/24/Action/Edit.js";
import "../../../icons/24/Action/ErrorCheck.js";
import "../../../icons/24/Action/ErrorMinus.js";
import "../../../icons/24/Action/ErrorPlus.js";
import "../../../icons/24/Action/EyeDropper.js";
import "../../../icons/24/Action/EyeOff.js";
import "../../../icons/24/Action/EyeOn.js";
import "../../../icons/24/Action/File.js";
import "../../../icons/24/Action/FileCheck.js";
import "../../../icons/24/Action/FilePdf.js";
import "../../../icons/24/Action/FilePlus.js";
import "../../../icons/24/Action/Folder.js";
import "../../../icons/24/Action/FolderPlus.js";
import "../../../icons/24/Action/Hand.js";
import "../../../icons/24/Action/Heart.js";
import "../../../icons/24/Action/Image.js";
import "../../../icons/24/Action/Key.js";
import "../../../icons/24/Action/Location.js";
import "../../../icons/24/Action/Lock.js";
import "../../../icons/24/Action/Map.js";
import "../../../icons/24/Action/MassInput.js";
import "../../../icons/24/Action/Message.js";
import "../../../icons/24/Action/MessageOpen.js";
import "../../../icons/24/Action/MessageSend.js";
import "../../../icons/24/Action/PanelExpand.js";
import "../../../icons/24/Action/PanelHide.js";
import "../../../icons/24/Action/PauseCircle.js";
import "../../../icons/24/Action/Pin.js";
import "../../../icons/24/Action/PinSlash.js";
import "../../../icons/24/Action/PlayCircle.js";
import "../../../icons/24/Action/Print.js";
import "../../../icons/24/Action/Rating.js";
import "../../../icons/24/Action/RequestSend.js";
import "../../../icons/24/Action/SlidersHorizontal.js";
import "../../../icons/24/Action/SlidersVertical.js";
import "../../../icons/24/Action/SortAscending.js";
import "../../../icons/24/Action/SortDescending.js";
import "../../../icons/24/Action/StopCircle.js";
import "../../../icons/24/Action/Terminal.js";
import "../../../icons/24/Action/Unlock.js";
import "../../../icons/24/Action/User.js";
import "../../../icons/24/Action/UserInfo.js";
import "../../../icons/24/Action/UserPlus.js";
import "../../../icons/24/Action/UsersThree.js";
import "../../../icons/24/Arrow/ArrowDown.js";
import "../../../icons/24/Arrow/ArrowLeft.js";
import "../../../icons/24/Arrow/ArrowRedo.js";
import "../../../icons/24/Arrow/ArrowRefresh.js";
import "../../../icons/24/Arrow/ArrowRight.js";
import "../../../icons/24/Arrow/ArrowRotate.js";
import "../../../icons/24/Arrow/ArrowSquareOut.js";
import "../../../icons/24/Arrow/ArrowUndo.js";
import "../../../icons/24/Arrow/ArrowUp.js";
import "../../../icons/24/Arrow/ArrowUpLeft.js";
import "../../../icons/24/Arrow/ArrowUpRight.js";
import "../../../icons/24/Arrow/ArrowsDownUp.js";
import "../../../icons/24/Arrow/ArrowsLeftRight.js";
import "../../../icons/24/Arrow/ArrowsOutCardinal.js";
import "../../../icons/24/Arrow/ArrowsSort.js";
import "../../../icons/24/Arrow/ChevronDoubleLeft.js";
import "../../../icons/24/Arrow/ChevronDoubleRight.js";
import "../../../icons/24/Arrow/ChevronRight.js";
import "../../../icons/24/Arrow/ChevronUp.js";
import "../../../icons/24/Arrow/CollapseWindow.js";
import "../../../icons/24/Arrow/ExpandWindow.js";
import "../../../icons/24/Arrow/Request.js";
import "../../../icons/24/Emotion/Bad.js";
import "../../../icons/24/Emotion/Good.js";
import "../../../icons/24/Emotion/Neutral.js";
import "../../../icons/24/Emotion/VeryBad.js";
import "../../../icons/24/Emotion/VeryGood.js";
import "../../../icons/24/Math/Average.js";
import "../../../icons/24/Math/Divide.js";
import "../../../icons/24/Math/Equals.js";
import "../../../icons/24/Math/Less.js";
import "../../../icons/24/Math/LessEquals.js";
import "../../../icons/24/Math/Minus.js";
import "../../../icons/24/Math/MinusCircle.js";
import "../../../icons/24/Math/More.js";
import "../../../icons/24/Math/MoreEquals.js";
import "../../../icons/24/Math/NoEquals.js";
import "../../../icons/24/Math/Number.js";
import "../../../icons/24/Math/Plus.js";
import "../../../icons/24/Math/PlusCircle.js";
import "../../../icons/24/Math/X.js";
import "../../../icons/24/Menu/Archive.js";
import "../../../icons/24/Menu/Billing.js";
import "../../../icons/24/Menu/BoardGraph.js";
import "../../../icons/24/Menu/BoardText.js";
import "../../../icons/24/Menu/Buildings.js";
import "../../../icons/24/Menu/BurgerMenu.js";
import "../../../icons/24/Menu/CalendarBlank.js";
import "../../../icons/24/Menu/CalendarCheck.js";
import "../../../icons/24/Menu/ChartLine.js";
import "../../../icons/24/Menu/ChartLineUp.js";
import "../../../icons/24/Menu/Cytology.js";
import "../../../icons/24/Menu/Dashboard.js";
import "../../../icons/24/Menu/Emailbook.js";
import "../../../icons/24/Menu/GenderFemale.js";
import "../../../icons/24/Menu/GenderMale.js";
import "../../../icons/24/Menu/Hospital.js";
import "../../../icons/24/Menu/Lightning.js";
import "../../../icons/24/Menu/Microbiology.js";
import "../../../icons/24/Menu/Microphone.js";
import "../../../icons/24/Menu/Microscope.js";
import "../../../icons/24/Menu/Monitor.js";
import "../../../icons/24/Menu/MonitorGraph.js";
import "../../../icons/24/Menu/Note.js";
import "../../../icons/24/Menu/NoteSearch.js";
import "../../../icons/24/Menu/Notebook.js";
import "../../../icons/24/Menu/Order.js";
import "../../../icons/24/Menu/Package.js";
import "../../../icons/24/Menu/PencilCircle.js";
import "../../../icons/24/Menu/Phone.js";
import "../../../icons/24/Menu/PhoneArrow.js";
import "../../../icons/24/Menu/PhoneCall.js";
import "../../../icons/24/Menu/PhoneCheck.js";
import "../../../icons/24/Menu/Phonebook.js";
import "../../../icons/24/Menu/Plugs.js";
import "../../../icons/24/Menu/PlusMinus.js";
import "../../../icons/24/Menu/Relations.js";
import "../../../icons/24/Menu/Robot.js";
import "../../../icons/24/Menu/Room.js";
import "../../../icons/24/Menu/Selections.js";
import "../../../icons/24/Menu/Smartphone.js";
import "../../../icons/24/Menu/Stethoscope.js";
import "../../../icons/24/Menu/TestFlask.js";
import "../../../icons/24/Menu/TestTube.js";
import "../../../icons/24/Menu/TestTubeArchive.js";
import "../../../icons/24/Menu/TestTubeControl.js";
import "../../../icons/24/Menu/TestTubeReception.js";
import "../../../icons/24/Menu/TestTubeRegistration.js";
import "../../../icons/24/Menu/Tray.js";
import "../../../icons/24/Menu/UserCircle.js";
import "../../../icons/24/Menu/Wrench.js";
import "../../../icons/24/Menu/FirstAidKit.js";
import "../../../icons/24/Menu/СhartBar.js";
import "../../../icons/24/System/Alarm.js";
import "../../../icons/24/System/Barcode.js";
import "../../../icons/24/System/Calendar.js";
import "../../../icons/24/System/Checks.js";
import "../../../icons/24/System/Clock.js";
import "../../../icons/24/System/CloudDownload.js";
import "../../../icons/24/System/CloudUpload.js";
import "../../../icons/24/System/DotsSixHorizontal.js";
import "../../../icons/24/System/DotsSixVertical.js";
import "../../../icons/24/System/DotsThreeHorizontal.js";
import "../../../icons/24/System/DotsThreeVertical.js";
import "../../../icons/24/System/Download.js";
import "../../../icons/24/System/Link.js";
import "../../../icons/24/System/LinkBreak.js";
import "../../../icons/24/System/Loader.js";
import "../../../icons/24/System/Notification.js";
import "../../../icons/24/System/QRcode.js";
import "../../../icons/24/System/Settings.js";
import "../../../icons/24/System/Shield.js";
import "../../../icons/24/System/SignIn.js";
import "../../../icons/24/System/SignOut.js";
import "../../../icons/24/System/Spinner.js";
import "../../../icons/24/System/Upload.js";
import "../../../icons/24/System/ZoomIn.js";
import "../../../icons/24/System/ZoomOut.js";
import "../../../icons/24/Text/Aa.js";
import "../../../icons/24/Text/AlignCenter.js";
import "../../../icons/24/Text/AlignLeft.js";
import "../../../icons/24/Text/AlignRight.js";
import "../../../icons/24/Text/Bolder.js";
import "../../../icons/24/Text/Columns.js";
import "../../../icons/24/Text/H.js";
import "../../../icons/24/Text/Italic.js";
import "../../../icons/24/Text/ListBullets.js";
import "../../../icons/24/Text/ListNumbers.js";
import "../../../icons/24/Text/Rows.js";
import "../../../icons/24/Text/Strikethrough.js";
import "../../../icons/24/Text/Table.js";
import "../../../icons/24/Text/TableDouble.js";
import "../../../icons/24/Text/Underline.js";
import "../../../icons/24/Warning/Attention.js";
import "../../../icons/24/Warning/Error.js";
import "../../../icons/24/Warning/Info.js";
import "../../../icons/24/Warning/Question.js";
import "../../../icons/24/Warning/Success.js";
import "../../../components/Avatar/styles.js";
import "../../../components/CheckboxGroup/Checkbox/styles.js";
import "../../../components/CheckboxGroup/styles.js";
import "../../../components/RadioGroup/Radio/styles.js";
import "../../../components/RadioGroup/styles.js";
import "../../../components/RatingButton/styles.js";
import "../../../components/FloatingActionButton/styles.js";
import "../../../components/SortingButton/styles.js";
import "../../../components/SquareButton/styles.js";
import "../../../components/Toggle/styles.js";
import "../../../components/Dialog/Dialog.js";
import "../../../components/Dialog/DialogTitle.js";
import "../../../components/Dialog/DialogActions.js";
import "../../../components/Dialog/DialogContent.js";
import "../../../components/Chips/Chip/styles.js";
import "../../../components/ResultMarksNumber/styles.js";
import "../../../components/Progress/ProgressCircle/styles.js";
import "../../../components/Loaders/LoaderCircle/styles.js";
import "../../../components/Loaders/LoaderLine/styles.js";
import "../../../components/SegmentedControl/styles.js";
import "../../../components/ResultMarksText/styles.js";
import "../../../components/Link/Link.js";
import "../../../components/Tag/Tag.js";
import "../../../components/DatePicker/constants.js";
import "../../../components/DatePicker/shared/fragments/CalendarCell/CalendarCell.js";
import "../../../vendor/classnames/index.js";
import "../../../components/Scrollbar/Scrollbar.js";
import "../../../components/DatePicker/shared/fragments/MonthYearSelector/YearSelector.js";
import "../../../components/DatePicker/components/RangePicker/context/DateRangePickerContext.js";
import "../../../components/DatePicker/components/RangePicker/context/DateRangePickerContextActions.js";
import "../../../components/DatePicker/components/DatePicker/context/DatePickerContext.js";
import "../../../components/DatePicker/components/DatePicker/context/DatePickerContextActions.js";
import "../../../components/MobileBottomSheet/MobileBottomSheet.js";
import "../../../components/ListItem/ListItem.js";
import "../../../components/Nowrap.js";
import "../../../components/List/ListItemTree/TreeListItem.js";
import "../../../components/List/ListItemTree/components/Label.js";
import "../../../icons/IconsFilled/24/Alert/Success.js";
import "../../../icons/IconsFilled/24/Alert/Information.js";
import "../../../icons/IconsFilled/24/Alert/Attention.js";
import "../../../icons/IconsFilled/24/Alert/Error.js";
import "../../../components/Tabs/styles.js";
import "../../../components/Tabs/context.js";
import "../../../components/CounterInput/Input.js";
import "../../../components/PinCodeControl/PinCodeInput.js";
import { redDefaultMarker } from "./b64Images.js";
const defaultCoords = { lat: 39.8097343, lng: -98.5556199 }, defaultMapSettings = {
  center: defaultCoords,
  zoom: 4
}, useGoogleMap = ({
  zoom = defaultMapSettings.zoom,
  center = defaultMapSettings.center,
  googlePlace,
  marker: markerImage
} = defaultMapSettings) => {
  const ref = useRef(null), refInfoWindow = useRef(null), loader = useGoogleLoader(), [state, setState] = useState({}), [tooltip, setTooltipInfo] = useState({ header: "", info: "" });
  useEffect(() => {
    let map;
    return loader == null || loader.importLibrary("maps").then(({ Map, InfoWindow }) => {
      if (!ref.current)
        return;
      map = new Map(ref.current, {
        center: { lat: center == null ? void 0 : center.lat, lng: center == null ? void 0 : center.lng },
        streetViewControl: !1,
        mapTypeControl: !1,
        zoom
      }), map.addListener("click", async (e) => {
        e.latLng;
      });
      const marker2 = new google.maps.Marker({
        map,
        icon: markerImage ?? redDefaultMarker,
        anchorPoint: new google.maps.Point(0, -29)
      });
      marker2.setVisible(!1);
      let infoWindow2;
      refInfoWindow.current && (infoWindow2 = new InfoWindow(), infoWindow2.setContent(refInfoWindow.current)), marker2.addListener("click", () => {
        infoWindow2 == null || infoWindow2.open(map, marker2), refInfoWindow.current && (refInfoWindow.current.style.display = "block");
      }), setState({ map, infoWindow: infoWindow2, marker: marker2 });
    }), () => {
      setState({}), map && (map.unbindAll(), google.maps.event.clearInstanceListeners(map));
    };
  }, [center == null ? void 0 : center.lat, center == null ? void 0 : center.lng, loader, markerImage, zoom]);
  const { marker, infoWindow } = state;
  useEffect(() => {
    marker && infoWindow && googlePlace && (infoWindow.open(null, marker), refInfoWindow.current && (refInfoWindow.current.style.display = "block"));
  }, [googlePlace, infoWindow, marker]);
  const setMapPlace = useCallback(
    (place) => {
      var _a, _b, _c, _d, _e, _f, _g, _h;
      if ((_a = state.infoWindow) == null || _a.close(), refInfoWindow.current && (refInfoWindow.current.style.display = "none"), (_b = state.marker) == null || _b.setVisible(!1), !((_c = place.geometry) != null && _c.location)) {
        console.error("No details available for input: '" + place.name + "'");
        return;
      }
      place.geometry.viewport ? (_d = state.map) == null || _d.fitBounds(place.geometry.viewport) : ((_e = state.map) == null || _e.setCenter(place.geometry.location), (_f = state.map) == null || _f.setZoom(17)), (_g = state.marker) == null || _g.setPosition(place.geometry.location), (_h = state.marker) == null || _h.setVisible(!0);
    },
    [state.infoWindow, state.map, state.marker]
  ), setMapPlaceRef = useRef(setMapPlace);
  return setMapPlaceRef.current = setMapPlace, useLayoutEffect(() => {
    if (googlePlace && state.map) {
      setMapPlaceRef.current(googlePlace);
      const { formattedAddress, streetAddress } = getAddressInfo(googlePlace) ?? "";
      setTooltipInfo({
        info: formattedAddress,
        header: streetAddress ?? formattedAddress.split(",")[0] ?? ""
      });
    }
  }, [state.map, googlePlace]), {
    mapRef: ref,
    tooltipRef: refInfoWindow,
    tooltip,
    setMapPlace,
    reset: () => {
      var _a, _b, _c, _d;
      (_a = state.map) == null || _a.setCenter(defaultCoords), (_b = state.map) == null || _b.setZoom(4), (_c = state.infoWindow) == null || _c.close(), refInfoWindow.current && (refInfoWindow.current.style.display = "none"), (_d = state.marker) == null || _d.setVisible(!1);
    },
    ...state
  };
};
export {
  useGoogleMap
};
//# sourceMappingURL=useGoogleMap.js.map
